import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TabContext } from '../TabContext';

const TabNav = ({ children, steps = false }) => {
    const { tabIndex, setTabIndex, tabTouched } = useContext(TabContext);

    return (
        <nav className="tabs__header">
            <ul className={`tabs__list ${steps ? '-steps' : ''}`}>
                {React.Children.toArray(children)
                    .filter((e) => e)
                    .map((child, index) => (
                        <li
                            className={`tabs__tab ${tabIndex === index ? '-active' : ''} ${
                                tabTouched && tabIndex !== index ? '-gray' : ''
                            }`}
                            key={`tab${index}`}
                        >
                            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/role-supports-aria-props */}
                            <div
                                id={`tab${index}`}
                                tabIndex={index}
                                role="button"
                                aria-selected={tabIndex === index}
                                aria-controls={`tab${index}-panel`}
                                className="tabs__button"
                                onClick={() => {
                                    if (!steps || tabIndex > index) {
                                        setTabIndex(index);
                                    }
                                }}
                            >
                                <span className="tabs__buttonText">{child}</span>
                            </div>
                        </li>
                    ))}
            </ul>
        </nav>
    );
};

TabNav.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.element])),
    ]),
    steps: PropTypes.bool,
};

export default TabNav;
